import { render, staticRenderFns } from "./shelf.vue?vue&type=template&id=258a1718&scoped=true&"
import script from "./shelf.vue?vue&type=script&lang=js&"
export * from "./shelf.vue?vue&type=script&lang=js&"
import style0 from "./shelf.vue?vue&type=style&index=0&id=258a1718&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a1718",
  null
  
)

export default component.exports